export const JobService = {
  AWS_MEDIACONVERT: 101,
  CUSTOM_IMAGE_CONVERTER: 201,
  SUBTITLES_CONVERT: 301,
} as const;
